import { useTranslation } from 'react-i18next';
import PublicLayout from './PublicLayout';

export default function CookiesPage() {
  const { t } = useTranslation();

  return (
    <PublicLayout>
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <h1 className="text-4xl font-bold text-gray-900 mb-2">{t('cookies.title')}</h1>
        <p className="text-gray-500 mb-12">{t('cookies.lastUpdated')}</p>

        <div className="prose prose-lg max-w-none space-y-8">
          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-3">{t('cookies.whatAreCookiesTitle')}</h2>
            <p className="text-gray-600 leading-relaxed">{t('cookies.whatAreCookiesText')}</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-3">{t('cookies.whatCookiesTitle')}</h2>
            <div className="space-y-4">
              <div className="border border-gray-200 rounded-xl p-5">
                <div className="flex items-center gap-2 mb-2">
                  <span className="px-2.5 py-1 bg-green-100 text-green-700 text-xs font-medium rounded-full">{t('cookies.essentialBadge')}</span>
                  <h3 className="font-semibold text-gray-900">{t('cookies.authCookiesTitle')}</h3>
                </div>
                <p className="text-gray-600 text-sm">{t('cookies.authCookiesText')}</p>
                <div className="mt-2 text-xs text-gray-400">
                  <code>AUTH_SESSION_ID</code>, <code>KC_RESTART</code>, <code>KEYCLOAK_SESSION</code>
                </div>
              </div>

              <div className="border border-gray-200 rounded-xl p-5">
                <div className="flex items-center gap-2 mb-2">
                  <span className="px-2.5 py-1 bg-green-100 text-green-700 text-xs font-medium rounded-full">{t('cookies.essentialBadge')}</span>
                  <h3 className="font-semibold text-gray-900">{t('cookies.functionalCookiesTitle')}</h3>
                </div>
                <p className="text-gray-600 text-sm">{t('cookies.functionalCookiesText')}</p>
              </div>

              <div className="border border-gray-200 rounded-xl p-5">
                <div className="flex items-center gap-2 mb-2">
                  <span className="px-2.5 py-1 bg-blue-100 text-blue-700 text-xs font-medium rounded-full">{t('cookies.analyticsBadge')}</span>
                  <h3 className="font-semibold text-gray-900">{t('cookies.analyticsCookiesTitle')}</h3>
                </div>
                <p className="text-gray-600 text-sm">{t('cookies.analyticsCookiesText')}</p>
              </div>
            </div>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-3">{t('cookies.manageCookiesTitle')}</h2>
            <p className="text-gray-600 leading-relaxed">{t('cookies.manageCookiesText')}</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-3">{t('cookies.thirdPartyCookiesTitle')}</h2>
            <p className="text-gray-600 leading-relaxed">{t('cookies.thirdPartyCookiesText')}</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-3">{t('cookies.contactTitle')}</h2>
            <p className="text-gray-600 leading-relaxed">
              {t('cookies.contactText')}{' '}
              <a href="mailto:privacy@ai-ia.dev" className="text-blue-600 hover:underline">privacy@ai-ia.dev</a>
            </p>
          </section>
        </div>
      </div>
    </PublicLayout>
  );
}
